module.exports = __webpack_public_path__ + "static/media/sculpture5.9f1e365b.jpg";